import {
  aGoogleMapIsPanning,
  aGoogleMapIsWheelZooming,
  aGoogleMapIsZooming,
  aGoogleMapSimplifiedMode,
  useAtomValue,
} from '~/atoms'

export function useGoogleMapLayerVisibility() {
  const isSimplifiedMode = useAtomValue(aGoogleMapSimplifiedMode)
  const isPanning = useAtomValue(aGoogleMapIsPanning)
  const isWheelZooming = useAtomValue(aGoogleMapIsWheelZooming)
  const isZooming = useAtomValue(aGoogleMapIsZooming)
  const hideMovingLayers = isSimplifiedMode && (isPanning || isZooming)

  return {
    hideMovingLayers,
    hideOptionalDeckLayers: isSimplifiedMode,
    isPanning,
    isSimplifiedMode,
    isWheelZooming,
    isZooming,
    useZoomSafeListingPresentation:
      isSimplifiedMode && isWheelZooming && !isPanning,
  }
}
